<script setup>
import BreezeButton from "@/Components/AuthButton.vue";
import BreezeGuestLayout from "@/Layouts/Guest.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";

defineProps({
  status: String,
});

const form = useForm({
  email: "",
});

const submit = () => {
  form.post(route("password.email"));
};
</script>

<template>
  <BreezeGuestLayout>
    <div
      class="
        w-full
        sm:max-w-lg
        mt-6
        px-24
        py-12
        bg-oteoBlue-600
        shadow-md
        overflow-hidden
        sm:rounded-lg
      "
    >
      <Head title="Passwort vergessen" />

      <div class="mb-4 text-sm text-white">
        Sie haben Ihr Passwort vergessen? Das ist kein Problem. Teilen Sie uns
        einfach Ihre E-Mail-Adresse mit und wir senden Ihnen einen Link zum
        Zurücksetzen des Passworts zu, mit dem Sie ein neues wählen können.
      </div>

      <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <BreezeValidationErrors class="mb-4" />

      <form @submit.prevent="submit">
        <div>
          <BreezeLabel for="email" value="E-Mail Adresse" />
          <BreezeInput
            id="email"
            type="email"
            class="mt-1 block w-full"
            v-model="form.email"
            required
            autofocus
            autocomplete="email"
          />
        </div>

        <div class="mt-4">
          <BreezeButton
            class="w-full justify-center text-white"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Passwort zurücksetzen
          </BreezeButton>
        </div>
      </form>
    </div>
  </BreezeGuestLayout>
</template>
